<template>
	<div class="chart" id="charts_canvas" ref="chartRef">
		
	</div>
</template>

<script>
// const getFile = (url) => {
// 	return new Promise((resolve, reject) => {
// 		var credentials = {
// 			accessKeyId: "AKIATLPEDU37QV5CHLMH",
// 			secretAccessKey: "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",
// 		}; //秘钥形式的登录上传
// 		window.AWS.config.update(credentials);
// 		window.AWS.config.region = "cn-northwest-1"; //设置区域
// 		let url2 = url;
// 		let _url2 = "";
// 		if (
// 			url2.indexOf("https://view.officeapps.live.com/op/view.aspx?src=") != -1
// 		) {
// 			_url2 = url2.split(
// 				"https://view.officeapps.live.com/op/view.aspx?src="
// 			)[1];
// 		} else {
// 			_url2 = url2;
// 		}
// 		var s3 = new window.AWS.S3({ params: { Bucket: "ccrb" } });
// 		let name = decodeURIComponent(
// 			_url2.split("https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/")[1]
// 		);
// 		var params = {
// 			Bucket: "ccrb",
// 			Key: name,
// 		};
// 		s3.getObject(params, function (err, data) {
// 			if (err) {
// 				console.log(err, err.stack);
// 				resolve({ data: 1 });
// 			} else {
// 				const fileContent = data.Body.toString("utf-8");
// 				resolve({ data: fileContent });
// 			} // sxuccessful response
// 		});
// 		// axios({
// 	});
// };
export default {
	props: {
		data: {
			type: Object,
			default: ()=>{},
		},
	},
	data() {
		return {
			chartObj:null,
			chartData:null,
		};
	},
	watch:{
		data(){
			this.getChartData();
		}
	},
	methods: {
		getChartData() {
			this.chartObj = this.$echarts.init(
        this.$refs.chartRef
      );
			this.chartObj.setOption(this.data);
		},
	},
	mounted() {
		this.getChartData();
		window.addEventListener("resize",()=>{
			this.chartObj.resize();
		})
	},
};
</script>

<style scoped>
.chart {
	max-width: 100%;
	width: 100%;
	height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/contrastObservation/component/chart.vue